import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class PreformanceStatusService {

  readonly rootUrl = AppSettings.webApiURL; 
  constructor(public httpClient: HttpClient) { }

  public GetMonths() {
    return this.httpClient.get(`${this.rootUrl}/api/PreformanceStatus/GetMonths`);
  }

  getAccountManagersDDL() {
    return this.httpClient.get(`${this.rootUrl}/api/PreformanceStatus/GetAccountManagersDDL`);
  }

  getCustomers(accoountManagers) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/PreformanceStatus/GetCustomers`, accoountManagers, { headers });
  }

  public getData(accountManager, month) {
    return this.httpClient.get(`${this.rootUrl}/api/PreformanceStatus/GetPreformanceStatus?accountManager=${accountManager == null ? '' : accountManager}&reportMonth=${month}`);
  }

  public getDataDetailed(accountManagers, customers, month) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    let filter = {AccountManager: accountManagers, Customers: customers, ReportMonth: month}
    return this.httpClient.post(`${this.rootUrl}/api/PreformanceStatus/GetPreformanceStatusDetailed`, filter, { headers });
  }





}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/preformance-status.service.ts